import Vue from 'vue'

var nav=new Vue(); //中转站

export default nav;



// WEBPACK FOOTER //
// ./src/components/common/but.js